import {Col, Row} from 'react-bootstrap'

function ViewAll({data, cellModifier, fieldOrder}) {
  return (
    <Row className="px-3 pb-6">
      {fieldOrder.map(([key, label]) => {
        let value = data[key]

        if (data[key] !== undefined) {
          if (cellModifier && key in cellModifier) {
            value = cellModifier[key]({value, row: {original: data}})
          }

          return (
            <Col key={key} sm="6" className="px-3 fs-5 border">
              <Row className="h-100">
                <Col sm="5" className="text-capitalize text-gray-700 fw-semibold bg-light py-4">
                  {label}:
                </Col>
                <Col sm="7" className="text-gray-800 py-4">
                  {value}
                </Col>
              </Row>
            </Col>
          )
        }
      })}
    </Row>
  )
}

export default ViewAll
